
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 181 181","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M0 0h180.007v180.007H0z"}}),_c('path',{attrs:{"d":"M62.366 133.1l-28.554.045a71.285 71.285 0 0056.175 27.399c39.345 0 71.287-31.943 71.287-71.287 0-39.345-31.942-71.288-71.287-71.288-39.345 0-71.287 31.943-71.287 71.288a71.293 71.293 0 009.55 35.643","fill":"none","stroke":"#323232","stroke-width":"5.83"}}),_c('path',{attrs:{"d":"M115.997 44.206a52.019 52.019 0 00-26.01-6.97c-28.711 0-52.02 23.31-52.02 52.021a52.018 52.018 0 006.969 26.01","fill":"none","stroke":"#323232","stroke-width":"5.83"}}),_c('circle',{attrs:{"cx":"90.004","cy":"89.257","r":"10.452","fill":"none","stroke":"#323232","stroke-width":"5.83"}}),_c('path',{attrs:{"d":"M66.352 109.129l14.259-12.491M98.085 81.331l36.474-31.953","fill":"none","stroke":"#323232","stroke-width":"5.83"}}),_c('text',{attrs:{"x":"79.899","y":"138.028","font-family":"'MicrosoftYaHeiUI-Bold','Microsoft YaHei UI',sans-serif","font-weight":"700","font-size":"33.333","fill":"#323232"}},[_v('{{ text }}')])])
          )
        }
      }
    